<template>
  <div class="grey lighten-4">
    <div class="footer-table">
      <div style="width: 30%;"></div>
      <div class="fee d-flex justify-end" md="2"><span>+ {{ totalMoney.headFeeMoney | price }}</span></div>
      <div class="fee d-flex justify-end" md="2"><span>- {{ totalMoney.deductionFeeMoney | price }}</span></div>
      <div class="fee d-flex justify-end" md="2"><span>+ {{ totalMoney.arrearFeeMoney | price }}</span></div>
      <div class="fee d-flex justify-end" md="2"><span>- {{ totalMoney.refundFeeMoney | price }}</span></div>
      <div class="fee d-flex justify-end" md="2"><span>{{ totalMoney.totalMoney | price }}</span></div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      totalMoney: 'tuitionFeeReport/totalMoney',
      loading: 'tuitionFeeReport/loading',
    })
  },
}
</script>
<style lang="scss" scoped>
.footer-table {
  display: flex;
  height: 60px;
  align-items: center;
}

.footer-table>div {
  width: 14%;
  font-size: 14px;
  margin-right: 10px;
}

.fee {
  color: #fd6b6b !important;
  font-weight: 500;
}
</style>
